import React, { useState } from "react";
import "../assets/FundApproval.css";

const FundApprovalReport = () => {
  const [filters, setFilters] = useState({
    fromDate: "",
    toDate: "",
    utr: "",
    user: "",
  });

  const [requests, setRequests] = useState([
    { sn: 1, date: "2025-04-12", user: "Rajeev (MNG00004)", amount: 1000000, utr: "1212", status: "Pending" },
    { sn: 2, date: "2025-04-09", user: "Demo Agent (AGN00001)", amount: 100, utr: "1234567890-", status: "Pending" },
    { sn: 3, date: "2025-02-11", user: "AKASH (MNG00002)", amount: 40000, utr: "77452345", status: "Pending" },
    { sn: 4, date: "2025-01-21", user: "Demo Manager (MNG00001)", amount: 2000, utr: "5566gyuu7778", status: "Pending" },
    { sn: 5, date: "2025-01-15", user: "Demo Agent (AGN00001)", amount: 10000, utr: "23214234124", status: "Approved" },
    { sn: 6, date: "2025-01-01", user: "Rajeev (MNG00004)", amount: 10000, utr: "123456789", status: "Approved" }
  ]);

  const [selectedRequest, setSelectedRequest] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [newStatus, setNewStatus] = useState("");

  const handleChangeStatus = (request) => {
    setSelectedRequest(request);
    setModalOpen(true);
  };

  const confirmStatusChange = () => {
    if (newStatus && selectedRequest) {
      setRequests((prev) =>
        prev.map((req) =>
          req.sn === selectedRequest.sn ? { ...req, status: newStatus } : req
        )
      );
    }
    setModalOpen(false);
    setSelectedRequest(null);
    setNewStatus("");
  };

  return (
    <div className="FundRequestApproval-container">
      <h1 className="FundRequestApproval-title">Fund Approval Report</h1>

      {/* Filter Section */}
      <div className="FundRequestApproval-filterSection">
        <div>
          <label>From Date</label>
          <input type="date" placeholder="dd-mm-yyyy" />
        </div>
        <div>
          <label>To Date</label>
          <input type="date" placeholder="dd-mm-yyyy" />
        </div>
        <div>
          <label>UTR Number</label>
          <input type="text" placeholder="Enter UTR number" />
        </div>
        <div>
          <label>User</label>
          <select>
            <option value="">Select User</option>
            <option>Rajeev (MNG00004)</option>
            <option>Demo Agent (AGN00001)</option>
            <option>AKASH (MNG00002)</option>
            <option>Demo Manager (MNG00001)</option>
          </select>
        </div>
        <button className="FundRequestApproval-btn search">Search</button>
      </div>

      {/* Table Section */}
      <div className="FundRequestApproval-tableWrapper">
        <h2 className="FundRequestApproval-subTitle">Report List</h2>
        <table className="FundRequestApproval-table">
          <thead>
            <tr>
              <th>S.N.</th>
              <th>Date</th>
              <th>User</th>
              <th>Amount</th>
              <th>UTR</th>
              <th>Slip</th>
              <th>Status</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {requests.map((req) => (
              <tr key={req.sn}>
                <td>{req.sn}</td>
                <td>{req.date}</td>
                <td>{req.user}</td>
                <td>{req.amount.toFixed(2)}</td>
                <td>{req.utr}</td>
                <td></td>
                <td>
                  <span className={`FundRequestApproval-status ${req.status.toLowerCase()}`}>
                    {req.status}
                  </span>
                </td>
                <td>
                  <button
                    className="FundRequestApproval-btn action"
                    onClick={() => handleChangeStatus(req)}
                  >
                    Change Status
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {modalOpen && selectedRequest && (
        <div className="FundRequestApproval-modalOverlay" onClick={() => setModalOpen(false)}>
          <div className="FundRequestApproval-modal" onClick={(e) => e.stopPropagation()}>
            <h2>Update Status</h2>
            <p><strong>User:</strong> {selectedRequest.user}</p>
            <p><strong>Amount:</strong> ₹{selectedRequest.amount.toLocaleString()}</p>
            <p><strong>Current Status:</strong> {selectedRequest.status}</p>

            <label>Select New Status</label>
            <select
              value={newStatus}
              onChange={(e) => setNewStatus(e.target.value)}
              className="FundRequestApproval-select"
            >
              <option value="">Select</option>
              <option value="Approved">Approved</option>
              <option value="Hold">Hold</option>
              <option value="Debit">Debit</option>
            </select>

            <div className="FundRequestApproval-modalButtons">
              <button className="cancel" onClick={() => setModalOpen(false)}>Cancel</button>
              <button className="update" onClick={confirmStatusChange}>Update</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FundApprovalReport;
